import EssealPhoneInput from "@/components/EssealPhoneInput";
import { ResourceMetaCreate } from "@/graphql/generated/graphql";
import { FormHelperText, Checkbox, FormControl, FormControlLabel, TextField } from "@mui/material";
import { Grid } from "@mui/system";
import type { ResourceMetaChangeHandler } from "./types";

type SubContractorResourceFieldsProps = {
  isEditing: boolean;
  resourceMeta?: ResourceMetaCreate;
  inviteSubContractor: boolean;
  canSendInvite: boolean;
  onChange: ResourceMetaChangeHandler;
  setInviteSubContractor: React.Dispatch<React.SetStateAction<boolean>>;
};

const SubContractorResourceFields: React.FC<SubContractorResourceFieldsProps> = ({
  isEditing,
  resourceMeta,
  onChange,
  canSendInvite,
  inviteSubContractor,
  setInviteSubContractor
}) => {
  return (
    <>
      <Grid container size={12} p={2} direction="column">
        <TextField
          fullWidth
          sx={{ mb: 1 }}
          label="Point of Contact"
          value={resourceMeta?.pointOfContact || ""}
          onChange={(e) => onChange("pointOfContact", e.target.value)}
        />
        <TextField
          fullWidth
          label="Email"
          sx={{ mb: 1 }}
          value={resourceMeta?.email || ""}
          onChange={(e) => onChange("email", e.target.value)}
        />
        <EssealPhoneInput
          id="phone"
          name="phone"
          defaultCountry="GB"
          style={{ marginBottom: 1, width: "100%" }}
          label="Primary Phone"
          value={resourceMeta?.primaryPhone || ""}
          onChange={(e164) => onChange("primaryPhone", e164)}
        />
        {
          !isEditing &&
          <FormControl error={inviteSubContractor && !canSendInvite}>
            <FormControlLabel
              label="Invite Now"
              control={
                <Checkbox
                  onChange={(_, checked) => setInviteSubContractor(checked)}
                  checked={inviteSubContractor}
                  disabled={!canSendInvite}
                />
              }
            />
            {!inviteSubContractor && !canSendInvite && (
              <FormHelperText sx={{ color: "error.main" }}>
                Add “Point of Contact” and “Email” to enable inviting.
              </FormHelperText>
            )}
          </FormControl>
        }
      </Grid>
    </>
  );
};

export default SubContractorResourceFields;
